import config from 'js/app/config';
import user from 'js/lib/user';

import type { ContentSuggestion } from 'bundles/enterprise-admin-ai-program-builder/types';
import {
  PROGRAM_DESCRIPTION_MAX_LENGTH,
  PROGRAM_NAME_MAX_LENGTH,
} from 'bundles/enterprise-admin-constants/enterprise-admin-constants-index';
import enterpriseAdminUser from 'bundles/enterprise-admin/enterprise-admin-index';
import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

import _t from 'i18n!nls/enterprise-admin-ai-program-builder';

export const getProgramNameError = (allProgramNames?: string[], programName?: string) => {
  if (!programName) {
    return _t('Program name is required');
  }
  if (allProgramNames?.includes(programName)) {
    return _t('Program name already exists');
  }
  if (programName.length > PROGRAM_NAME_MAX_LENGTH) {
    return _t('Program name is too long');
  }
  return undefined;
};
export const getProgramDescriptionError = (programDescription?: string) => {
  if (programDescription && programDescription.length > PROGRAM_DESCRIPTION_MAX_LENGTH) {
    return _t('Program name is too long');
  }
  return undefined;
};

export const mapGeneratedSuggestionsToCSV = (suggestions: Array<ContentSuggestion>): string => {
  if (suggestions.length === 0) return '';

  // Get headers from first object
  const keys = [
    {
      COLLECTIONS: 'Collection',
      LEARNING_PATHS: 'Learning Path',
    }[suggestions[0].type],
    'Item Type',
    'Item Title',
    'Partner',
    'Link',
  ];

  // Create CSV rows
  const csvRows = [
    // Header row
    keys.join(','),
    // Data rows
    ...suggestions.flatMap((suggestion) =>
      suggestion.learningItems.map((item) =>
        [
          `"${suggestion.title}"`,
          `"${item.productType}"`,
          `"${item.name}"`,
          `"${item.partners.map((partner) => partner.name).join(',')}"`,
          `"${config.url.base}${item.preview.slice(1)}"`, // Remove the leading '/' from the preview URL because the url base already has it
        ].join(',')
      )
    ),
  ];

  return csvRows.join('\n');
};

export const enableProgramBuilder = (thirdPartySlug: string) => {
  const enableProgramBuilderForOrg = EnterpriseExperiments.get('enableProgramBuilderForOrg').includes(thirdPartySlug);
  const enableProgramBuilderForACourserian = EnterpriseExperiments.get('enableAiProgramBuilder') && user.isCourserian();
  const enableProgramBuilderForWES =
    !enterpriseAdminUser.isStandardContractUser() && EnterpriseExperiments.get('enableProgramBuilderForWES');
  return enableProgramBuilderForOrg || enableProgramBuilderForACourserian || enableProgramBuilderForWES;
};

export const enableProgramBuilderForExistingPrograms = (thirdPartySlug: string) => {
  return enableProgramBuilder(thirdPartySlug) && EnterpriseExperiments.get('enableProgramBuilderForExistingPrograms');
};
